export default __webpack_public_path__ + "img/sagoo/seq/sagoo1_src.jpg";